"use strict";
exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/util/isArrayLike.js
// module id = 1r8+
// module chunks = 0